<template>
    <!-- 个股 - 板块 -->
    <div class="transpond_stock_wrap">
        <div
            class="transpond_stock_content"
            @click="handleClickToStockPage(stockInfo)"
        >
            <div class="transpond_title">
                <p
                    v-if="stock_market"
                    :class="[isGoUp(stock_market.chg_pct) ? 'to_red' : 'to_green', {
                        'stock_stock_info': type == 'stock',
                        'theme_stock_info': type == 'theme'
                    }]"
                >
                    <span v-if="type == 'stock'">{{ twoDecimalPlaces(stock_market.price + '') }}</span>
                    <span>{{ stock_market.chg_pct }}%</span>
                </p>
            </div>
            <div class="transpond_detail">
                <div class="transpond_list">
                    <p class="stock">
                        <span>{{ type == 'stock'?stockInfo.stock_name: stockInfo.title }}</span>
                        <span class="stock-code">&nbsp;({{ type == 'stock'?stockInfo.stock_code: stockInfo.symbol }})</span>
                    </p>
                    <div class="stock_info_right">
                        <p>
                            <span v-if="type == 'stock'">{{ stockInfo.comment_num }}</span>
                            <span v-else-if="type == 'theme'">近期讨论: {{ stockInfo.theme_num }}条</span>
                            <img :src="require('@/assets/images/icon-unfold.png')" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { isGoUp } from "@/utils/index";
import userHomeApi from "@/api/user_home/index.js";
export default {
    name: "stockCard",
    props: {
        stockInfo: {
            type: [Object],
            default: () => {
                return {

                }
            }
        },
        type: {
            type: String,
            default: "stock"
        }
    },
    data() {
        return {
            stock_market: null,
        }
    },
    created() {
        if(this.type == 'stock') {
            this.async_stock(this.stockInfo.stock_code)
        } else {
            this.stock_market = {
                chg_pct: (this.stockInfo.chg_pct > 0? '+' : '') + (this.stockInfo.chg_pct * 1).toFixed(2)
            }
        }
    },
    methods: {
        /* 异步请求行情接口 */
        async async_stock(stock_code) {
            let _code = stock_code;
            let data = null;
            switch (_code) {
                case "USDCNH": //离岸人民币
                    data = await userHomeApi.getUSDCNH({})
                    if (data.rslt == 'succ') {
                        let spl_data = data.data;
                        let obj = {
                            chg: (spl_data.current - spl_data.close).toFixed(2),
                            chg_pct: ((spl_data.current - spl_data.close) / spl_data.close * 100).toFixed(2),
                            price: (spl_data.current * 1).toFixed(2)
                        }
                        this.resetStock(obj);
                    }
                    break;
                case "CHA50CFD": //富时a50
                    data = await userHomeApi.getA50({})
                    if (data["A50"]) {
                        let spl_data = data["A50"].split(',')
                        let obj = {
                            chg: spl_data[1],
                            chg_pct: spl_data[2],
                            price: spl_data[0]
                        }
                        this.resetStock(obj);
                    }
                    break;
                case "DINIW": // 美元指数
                    data = await userHomeApi.getDINIW({})
                    if (data.rslt == 'succ') {
                        let spl_data = data.data;
                        let obj = {
                            chg: (spl_data.current - spl_data.close).toFixed(2),
                            chg_pct: ((spl_data.current - spl_data.close) / spl_data.close * 100).toFixed(2),
                            price: (spl_data.current * 1).toFixed(2)
                        }
                        this.resetStock(obj);
                    }
                    break;
                default:	// 港美股
                    if (_code.indexOf("US") > -1 || _code.indexOf("HK") > -1) {
                        data = await userHomeApi.getHKUS({
                            code: _code
                        })
                        if (data.rslt == 'succ') {// 名字，现价，昨收，涨额，涨幅，今开，最高，最低，交易量，交易额，市值，量比，委比，每手数，总股本，换手率，每股收益,时间
                            let spl_data = data.data.split(',')
                            let obj = {
                                chg: spl_data[3],
                                chg_pct: spl_data[4] * 100,
                                price: spl_data[1]
                            }
                            this.resetStock(obj);
                        }
                    } else {
                        data = await userHomeApi.getAStock({
                            list: _code + '_s'
                        })
                        if (data) {
                            let spl_data = data[_code + '_s'].split(',')
                            let obj = {
                                chg: spl_data[1],
                                chg_pct: spl_data[2],
                                price: spl_data[0]
                            }
                            this.resetStock(obj);
                        }
                    }
                    break;
            }
        },
        resetStock(_data) {
            _data.chg_pct = (_data.chg_pct > 0? '+' : '') + (_data.chg_pct * 1).toFixed(2)
            this.stock_market = _data;
            console.info('rsDown', _data)
        },
        // 点击事件 - 跳转详情页
        handleClickToStockPage(info) {
            if(this.type == 'stock') {
                this.openNative('stock_page', {
                    name: info.stock_name,
                    code: info.stock_code
                })
            } else if(this.type == 'theme') {
                this.openNative('theme_page', {
                    id: info.id
                })
            }
        },
        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            params = {
                ...params,
                ...query
            }

            switch(type) {
                case "stock_page": // 股票详情页
                    break;
                case "theme_page": // 板块详情页
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native',params)
        },
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
    //分享股票
    .transpond_stock_wrap {
        padding: rem2(10px) rem2(14px) rem2(10px);

        .transpond_stock_content {
            height: rem2(60px);
            padding: rem2(6px);
            background: rgba(255, 255, 255, 1);
            border-radius: rem2(10px);
            border: rem2(1px) solid rgba(245, 245, 245, 1);
            display: flex;
            box-sizing: border-box;
            box-shadow: rem2(0px) rem2(0px) rem2(14px) rem2(0px) rgba(67, 67, 67, 0.07);

            .transpond_title {
                width: rem2(85px);
                height: rem2(48px);
                margin-right: rem2(10px);

                .stock_stock_info {
                    height: rem2(48px);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    padding-left: rem2(9px);
                    box-sizing: border-box;
                    align-items: flex-start;
                    box-sizing: border-box;

                    &.to_green {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_stock_down.png);
                        background-size: 100%;
                    }

                    &.to_red {
                        background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_stock_up.png);
                        background-size: 100%;
                    }

                    >span {
                        display: block;
                        color: #ffffff;
                        font-size: rem2(15px);
                        font-style: normal;
                        font-weight: 700;
                        line-height: rem2(18px); /* 120% */

                        &:last-of-type {
                            font-weight: 500;
                            line-height: rem2(16px);
                            font-size: rem2(13px);
                            color: #fff;
                            margin-top: rem2(2px);
                        }
                    }
                }

                .theme_stock_info {
                    height: rem2(48px);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    padding-left: rem2(9px);
                    box-sizing: border-box;
                    align-items: flex-start;
                    box-sizing: border-box;
                    background-repeat: no-repeat;
                    justify-content: center;

                    &.to_green {
                        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/theme_green_icon.svg");
                        background-size: 100%;
                    }

                    &.to_red {
                        background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/theme_red_icon.svg");
                        background-size: 100%;
                    }

                    > span {
                        color: #FFF;
                        font-size: rem2(16px);
                        font-style: normal;
                        font-weight: 700;
                        line-height: rem2(21px);
                    }
                }
            }

            .transpond_detail {
                height: 100%;

                .transpond_list {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    font-size: rem2(15px);
                    color: #333;
                    font-weight: 500;

                    .stock-code {
                        color: #939393;
                        font-size: rem2(15px);
                        font-weight: 400;
                    }
                }

                .stock_info_right {
                    font-size: rem2(12px);
                    color: #9f9f9f;

                    >p {
                        display: flex;
                        align-items: center;

                        >img {
                            margin-left: rem2(5px);
                            transform: rotate(-90deg);
                            width: rem2(8px);
                            height: rem2(8px);
                        }
                    }
                }
            }
        }
    }
</style>